import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { logos, socialMediaUrl } from "../Details";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [showResume, setShowResume] = useState(false);
  const { linkdein, github, twitter } = socialMediaUrl;
  const resumeRef = useRef(null);
  const resumeBoxRef = useRef(null);

  const toggleClass = () => {
    setIsOpen(!isOpen);
  };

  const handleResumeMouseEnter = () => {
    setShowResume(true);
  };

  const handleResumeMouseLeave = () => {
    setShowResume(false);
  };

  // Close the resume box when clicking outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        resumeBoxRef.current &&
        !resumeBoxRef.current.contains(event.target) &&
        resumeRef.current &&
        !resumeRef.current.contains(event.target)
      ) {
        setShowResume(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDownloadCV = (type) => {
    // Create a link to download the CV
    const link = document.createElement("a");
    if (type === "ats") {
      link.href = "/Robert_OConnor_CV_ATS.pdf";
      link.download = "Robert_OConnor_CV_ATS.pdf";
    } else {
      link.href = "/Robert_OConnor_CV_Pretty.pdf";
      link.download = "Robert_OConnor_CV_Pretty.pdf";
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <header className="container mx-auto md:flex justify-between py-2 max-width">
      <div className="flex justify-between items-center py-2 md:py-10">
        <NavLink to="/">
          <img className="w-14" src={logos.logogradient} alt="logo" />
        </NavLink>
        <div onClick={toggleClass} className="cursor-pointer">
          <svg
            className="stroke-dark-heading dark:stroke-white md:hidden"
            width="25"
            height="20"
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.4375 1.3125H14.5625M1.4375 11.3125H14.5625H1.4375ZM1.4375 6.3125H14.5625H1.4375Z"
              strokeWidth="1.875"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      <nav
        className={` ${
          !isOpen ? "hidden" : null
        } text-center md:flex justify-between`}
      >
        <ul className="dark:text-light-content font-medium md:flex items-center md:space-x-5 md:mr-10">
          <li className="pb-1 md:pb-0">
            <NavLink to="/" onClick={toggleClass}>
              Home
            </NavLink>
          </li>
          <li className="pb-1 md:pb-0">
            <NavLink to="/about" onClick={toggleClass}>
              About
            </NavLink>
          </li>
          <li className="pb-1 md:pb-0">
            <NavLink to="/technologies" onClick={toggleClass}>
              Technologies
            </NavLink>
          </li>
          <li className="pb-1 md:pb-0">
            <NavLink to="/projects" onClick={toggleClass}>
              Projects
            </NavLink>
          </li>
          <li className="pb-1 md:pb-0">
            <NavLink to="/contact" onClick={toggleClass}>
              Contact
            </NavLink>
          </li>
          <li className="pb-1 md:pb-0 relative">
            <span
              ref={resumeRef}
              className="cursor-pointer hover:text-sky-500 transition-colors duration-300"
              onMouseEnter={handleResumeMouseEnter}
            >
              CV
            </span>
            {showResume && (
              <div
                ref={resumeBoxRef}
                className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 w-[350px] resume-popup z-50"
                onMouseLeave={handleResumeMouseLeave}
              >
                <div className="text-dark-heading dark:text-light-heading">
                  {/* PDF preview container - smaller height */}
                  <div className="h-[400px] w-full overflow-hidden mb-3 border border-gray-200 dark:border-gray-700 rounded">
                    {/* Using iframe with specific parameters to show only first page without controls */}
                    <iframe
                      src="/Robert_OConnor_CV_Pretty.pdf#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0"
                      width="100%"
                      height="100%"
                      className="pdf-preview"
                      frameBorder="0"
                      scrolling="no"
                      title="CV Preview"
                    ></iframe>
                  </div>

                  <div className="flex flex-col gap-2">
                    <button
                      onClick={() => handleDownloadCV("ats")}
                      className="w-full py-2 px-4 bg-gradient-to-r from-sky-500 via-purple-500 to-pink-600 text-white font-medium rounded-lg hover:opacity-90 transition-opacity duration-300"
                    >
                      ATS Friendly CV
                    </button>
                    <button
                      onClick={() => handleDownloadCV("pretty")}
                      className="w-full py-2 px-4 bg-gradient-to-r from-pink-600 via-purple-500 to-sky-500 text-white font-medium rounded-lg hover:opacity-90 transition-opacity duration-300"
                    >
                      Visually Appealing CV
                    </button>
                  </div>
                </div>
              </div>
            )}
          </li>
        </ul>
        <ul className="flex justify-evenly items-center my-5 md:my-0 md:space-x-5 md:mr-5">
          <li>
            <a href={linkdein} target="_blank" rel="noreferrer noopener">
              <svg
                className="dark:fill-light-heading fill-dark-heading"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15 0.599976C7.04701 0.599976 0.600006 7.04698 0.600006 15C0.600006 22.953 7.04701 29.4 15 29.4C22.953 29.4 29.4 22.953 29.4 15C29.4 7.04698 22.953 0.599976 15 0.599976ZM11.475 20.9685H8.55901V11.5845H11.475V20.9685ZM9.99901 10.4325C9.07801 10.4325 8.48251 9.77997 8.48251 8.97297C8.48251 8.14948 9.09601 7.51648 10.0365 7.51648C10.977 7.51648 11.553 8.14948 11.571 8.97297C11.571 9.77997 10.977 10.4325 9.99901 10.4325ZM22.125 20.9685H19.209V15.768C19.209 14.5575 18.786 13.7355 17.7315 13.7355C16.926 13.7355 16.4475 14.292 16.236 14.8275C16.158 15.018 16.1385 15.288 16.1385 15.5565V20.967H13.221V14.577C13.221 13.4055 13.1835 12.426 13.1445 11.583H15.678L15.8115 12.8865H15.87C16.254 12.2745 17.1945 11.3715 18.768 11.3715C20.6865 11.3715 22.125 12.657 22.125 15.42V20.9685Z" />
              </svg>
            </a>
          </li>
          <li>
            <a href={github} target="_blank" rel="noreferrer noopener">
              <svg
                className="dark:fill-light-heading fill-dark-heading"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15 0C6.7125 0 0 6.7125 0 15C0 21.6375 4.29375 27.2437 10.2563 29.2313C11.0063 29.3625 11.2875 28.9125 11.2875 28.5188C11.2875 28.1625 11.2688 26.9813 11.2688 25.725C7.5 26.4188 6.525 24.8062 6.225 23.9625C6.05625 23.5312 5.325 22.2 4.6875 21.8438C4.1625 21.5625 3.4125 20.8687 4.66875 20.85C5.85 20.8313 6.69375 21.9375 6.975 22.3875C8.325 24.6562 10.4812 24.0187 11.3438 23.625C11.475 22.65 11.8688 21.9937 12.3 21.6187C8.9625 21.2437 5.475 19.95 5.475 14.2125C5.475 12.5813 6.05625 11.2313 7.0125 10.1813C6.8625 9.80625 6.3375 8.26875 7.1625 6.20625C7.1625 6.20625 8.41875 5.8125 11.2875 7.74375C12.4875 7.40625 13.7625 7.2375 15.0375 7.2375C16.3125 7.2375 17.5875 7.40625 18.7875 7.74375C21.6562 5.79375 22.9125 6.20625 22.9125 6.20625C23.7375 8.26875 23.2125 9.80625 23.0625 10.1813C24.0188 11.2313 24.6 12.5625 24.6 14.2125C24.6 19.9688 21.0938 21.2437 17.7563 21.6187C18.3 22.0875 18.7688 22.9875 18.7688 24.3937C18.7688 26.4 18.75 28.0125 18.75 28.5188C18.75 28.9125 19.0312 29.3813 19.7812 29.2313C22.759 28.2259 25.3465 26.3121 27.1796 23.7592C29.0127 21.2063 29.9991 18.1429 30 15C30 6.7125 23.2875 0 15 0Z"
                />
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
